var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid index inner-view align-items-center m-0 p-5 py-0"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }